import cloneDeep from 'lodash/cloneDeep';

/**
 * Gets from an object by path.
 *
 * @example
 *   const input = {
 *     a: {
 *       b: [{ a: { c: 1 } }, { a: { c: 2 } }],
 *     },
 *   };
 *
 *   const output = getObjectByPath(input, 'a.b.1.a.c'); // return 2
 *
 * @param object The object to do the look up in.
 * @param path The path of the value delimited by a dot, e.g. `foo.bar.0.baz`.
 */
export function getObjectByPath<TObject>(
  object: TObject,
  path: string,
): TObject | undefined {
  let result = cloneDeep(object);
  const parts = path.split('.');

  for (let index = 0; index < parts.length; index++) {
    const element = parts[index];
    if (result[element]) {
      result = result[element];
    } else {
      return;
    }
  }

  return result;
}
